import { Box, Icon, Typography, styled } from "@outschool/backpack";
import { PastTeachersForParentProfileQuery } from "@outschool/gql-frontend-generated";
import { faPlay } from "@outschool/icons";
import { leaderPath } from "@outschool/routes";
import { UserHeadshotImage } from "@outschool/ui-components-shared";
import { useIsMobile, useLinkComponent } from "@outschool/ui-utils";
import React from "react";

import SimpleRatings from "../Reviews/SimpleRatings";

const StyledButton = styled("button")`
  background: none;
  border: none;
  cursor: pointer;
`;

const HEADSHOT_SIZE = 112;

type Props = {
  teacher: PastTeachersForParentProfileQuery["pastTeachersForParentProfile"][0];
  onWatchVideo: () => void;
};

export default function SimpleTeacherCard({ teacher, onWatchVideo }: Props) {
  const Link = useLinkComponent();
  const isMobile = useIsMobile();

  const LinkButton = ({ children }: { children: any }) =>
    !!teacher?.video ? (
      <StyledButton onClick={onWatchVideo}>{children}</StyledButton>
    ) : (
      <Link
        to={leaderPath(teacher.uid, teacher.leader_link)}
        target={!isMobile ? "_blank" : undefined}
      >
        {children}
      </Link>
    );

  return (
    <LinkButton>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          mb: "1rem",
          minWidth: `${HEADSHOT_SIZE}px`,
          paddingTop: `${HEADSHOT_SIZE - 14}px`,
        }}
      >
        <UserHeadshotImage
          user={teacher}
          size={HEADSHOT_SIZE}
          sx={{
            position: "absolute",
            top: 0,
          }}
        />
        {!!teacher?.video && (
          <Box
            flex
            sx={{
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              right: 6,
              top: "66px",
              zIndex: 2,
              width: "32px",
              height: "32px",
              backgroundColor: "primary.700",
              border: "3px solid",
              color: "white",
              borderRadius: "50%",
              boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
            }}
          >
            <Icon icon={faPlay} width={14} height={14} sx={{ ml: "3px" }} />
          </Box>
        )}
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "100px",
            paddingX: "8px",
            border: "2px solid",
            borderColor: "grey.50",
            zIndex: 1,
            color: "grey.900",
          }}
        >
          <SimpleRatings
            starRating={teacher.averageActivityStarRating}
            reviewCount={teacher.reviewCount}
          />
        </Box>
      </Box>

      <Typography
        variant="subtitle2"
        component="h3"
        sx={{
          display: "block",
          textAlign: "center",
          color: "grey.900",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {teacher.name}
      </Typography>
    </LinkButton>
  );
}
